import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="utils--push-notifications"
export default class extends Controller {
  async connect() {
    Notification.requestPermission().then((permission) => {
      if (permission !== 'granted') {
        console.warn('@ Permission not granted:', permission)
        return
      }
      this.saveTokenToBackend()
    })
  }

  saveTokenToBackend(token = null) {
    if (!token) {
      return
    }
    fetch('/notifications/save_token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ token: token })
    }).catch(err => console.error('Failed to send token to server:', err))
  }
}
